module.exports = createAudioContext
function createAudioContext () {
  var AudioCtor = window.AudioContext || window.webkitAudioContext
  return new AudioCtor()
}



//////////////////
// WEBPACK FOOTER
// ./~/web-audio-player/lib/audio-context.js
// module id = 941
// module chunks = 1 2 3 4 5